import { useCallback } from 'react';
import useThunkDispatch from '../../redux/useThunkDispatch';
import { showNotification } from '../actions';
import { NotificationType } from '../types';

export default function useShowNotification() {
  const dispatch = useThunkDispatch();
  return useCallback(
    (type: NotificationType, message: string): void => {
      dispatch(showNotification(type, message));
    },
    [dispatch],
  );
}
